import React, {useEffect, useRef} from "react";
import {useDispatch } from "react-redux";
import verifyEmailAndPass from "../../Actions/loginAction";
import { useLoginSuccess } from "../Hook/useLoginSuccess";

const EMAIL_OR_PASS_MATCHED = "EMAIL_OR_PASS_MATCHED";

const LoginForm = () => {
    const emailInputRef = useRef(null);
    const passInputRef = useRef(null);
    const loginRef = useRef(null);
    const passMatched = useLoginSuccess();
    const dispatch = useDispatch();
    const formSubmitBtnClicked = (event) => {
        event.preventDefault();
        const email = emailInputRef.current.value;
        const pass = passInputRef.current.value;
        loginRef.current.value = "Signing In";
        loginRef.current.disabled = true;
        dispatch({type: EMAIL_OR_PASS_MATCHED, payload: null});
        dispatch(verifyEmailAndPass(email, pass));
    }

    useEffect(() => {
        if (passMatched === false) {
            loginRef.current.value = "Sign In";
            loginRef.current.disabled = false;
            setTimeout(() => {
                dispatch({type: EMAIL_OR_PASS_MATCHED, payload: null});
            }, 10000);
        }
    }, [passMatched, dispatch])

    return (
        <div className="w-100 h-100 login-form-section">
            <div className="login-form-wrapper">
                <div className="login-title pb-2">Partner Sign In</div>
                <form className="login-form" onSubmit={formSubmitBtnClicked}>
                    <div className="d-flex flex-column">
                        <label className="sd-label" htmlFor="email">Email</label>
                        <input className="sd-input" type="email" ref={emailInputRef}
                               placeholder="Enter email associated with partner portal" name="email" required={true}/>
                    </div>
                    <div className="d-flex flex-column">
                        <label className="sd-label" htmlFor="password">Password</label>
                        <input className="sd-input" type="password" ref={passInputRef}
                               placeholder="Enter Password" name="password" required={true}/>
                    </div>
                    <div className="policy mb-2">
                            <span>By clicking Sign In, you agree to Shipday's &nbsp;
                                <a rel="noreferrer" href="https://www.shipday.com/terms"
                                   className="text-color-shipday-green "
                                   target="_blank">Terms of Service</a>
                                &nbsp; and acknowledge our &nbsp;
                                <a rel="noreferrer" href="https://www.shipday.com/privacy"
                                   className="text-color-shipday-green "
                                   target="_blank">privacy policy</a>
                            </span>
                    </div>
                    <div className="d-flex justify-content-center text-center">
                        <input ref={loginRef} type="submit" className="login-btn login-primary-btn w-100"
                               value="Sign In"/>
                    </div>
                </form>
            </div>
            <div className="text-start sd-label pt-5">Not a partner? <a href="/signup"
                                                                        className="link-success text-color-shipday-green">Sign
                Up</a></div>
            {passMatched === false &&
            <div className="alert alert-danger text-center wrong-pass-notification" role="alert">
                The email or password you entered is incorrect
            </div>}
        </div>
    );
}

export default LoginForm;
export {EMAIL_OR_PASS_MATCHED};
